import getIn from 'transmute/getIn';
import { Map as ImmutableMap, Set as ImmutableSet } from 'immutable';
import { getSelectedAssociations } from './getSelectedAssociations';
export const getObjectId = getIn(['objectId']);
export const getObjectTypeId = getIn(['objectTypeId']);
export const getDefaultAssociationsWithCallee = ({
  callableObject,
  uasAssociations
}) => {
  if (!callableObject) return null;
  const calleeId = `${getObjectId(callableObject)}`;
  const calleeObjectTypeId = getObjectTypeId(callableObject);
  const associations = uasAssociations.get('associations');
  if (!associations.size) {
    return ImmutableMap({
      [calleeObjectTypeId]: ImmutableSet([calleeId])
    });
  }
  const v2AssociationsData = getSelectedAssociations(associations);
  let associationsByTypeId = v2AssociationsData.map(association => {
    return association.get('objectIds');
  });
  const calleeObjectTypeAssociations = associationsByTypeId.get(calleeObjectTypeId);
  if (!calleeObjectTypeAssociations) {
    associationsByTypeId = associationsByTypeId.set(calleeObjectTypeId, ImmutableSet([calleeId]));
  } else if (!calleeObjectTypeAssociations.has(calleeId)) {
    associationsByTypeId = associationsByTypeId.update(calleeObjectTypeId, set => set.add(calleeId));
  }
  return associationsByTypeId;
};